import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { ByzMuiDtConfirmDialogProps } from './types';
import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

 const ByzMuiDtConfirmDialog = function ({
  title,
  content,
  action,
  open,
  onClose,
  ...other
}: ByzMuiDtConfirmDialogProps) {
  const { t } = useTranslate();

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}

      <DialogActions>
        {action}

        <Button variant="outlined" color="inherit" onClick={onClose}>
          {t("buttons.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}


export default ByzMuiDtConfirmDialog;